"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InclusiveGateway = void 0;
const Constants_1 = require("../Constants");
const Gateway_1 = require("./Gateway");
/**
 * Describes an InclusiveGateway.
 *
 * Currently not supported.
 */
class InclusiveGateway extends Gateway_1.Gateway {
    get bpmnType() {
        return Constants_1.BpmnType.inclusiveGateway;
    }
}
exports.InclusiveGateway = InclusiveGateway;
//# sourceMappingURL=InclusiveGateway.js.map